<template>
  <div>
    <Modal v-model="modal" :title="!agwWarningForm.id ? this.$t('alarms.network.AppGateway.addAppGatewayAlarm'):this.$t('alarms.network.AppGateway.editAppGatewayAlarm')" @on-cancel="cancel" @on-ok="ok" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :footer-hide="true" :closable="false">
      <Form ref="agwWarningForm" :model="agwWarningForm" :label-width="110"
            :rules="ruleValidate">
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" prop="ruleName" v-if="isEditRuleName">
            <Row>
              <Col span="11">
                <Input type="text" v-model="agwWarningForm.ruleName" placeholder="Enter something..."
                       style="width:300px;" :disabled="isEdit"></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{this.agwWarningForm.ruleName}}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select v-model="agwWarningForm.monitorIndex" filterable
                          @on-change="changeMonitorIndex(agwWarningForm.monitorIndex)" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select v-model="agwWarningForm.cycle" filterable :placeholder="$t('alarms.common.cycle')"
                          @on-change="changeCycle(agwWarningForm.cycle)">
                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select v-model="agwWarningForm.continousCycle" filterable :placeholder="$t('alarms.common.continuousCycle')"
                          @on-change="changeContinousCycle(agwWarningForm.continousCycle)">
                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="4">
                <FormItem prop="statisticsValue">
                  <Select v-model="agwWarningForm.statisticsValue" filterable :placeholder="$t('alarms.common.statisticsValue')"
                          @on-change="changeStatisticsValue(agwWarningForm.statisticsValue)">
                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>

                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select v-model="agwWarningForm.relationshipSign" filterable
                            @on-change="changeRelationshipSign(agwWarningForm.relationshipSign)"
                            :placeholder="$t('alarms.common.symbol')">
                      <Option :value="item.id" v-for="(item,index) in relationshipSignList" :key="index">{{item.name}}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input v-model="agwWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')" type="number"></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input v-model="agwWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                  </FormItem>
                </Col>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
              <RadioGroup v-model="agwWarningForm.contactType" @on-change="changeContactType(agwWarningForm.contactType)">
                  <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
              </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem :label="$t('alarms.common.notificationObject')" prop="notificationObject" v-if="agwWarningForm.contactType==0">
            <Select v-model="agwWarningForm.notificationObject" filterable multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

           <!-- 联系人组 -->
          <FormItem :label="$t('alarms.common.contactGroup')" prop="contactGroupIds" v-if="agwWarningForm.contactType==1">
            <Select v-model="agwWarningForm.contactGroupIds" filterable multiple style="width:300px;" @on-change="changeContactGroupId(agwWarningForm.contactGroupIds)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select v-model="agwWarningForm.noticeType" filterable multiple style="width:300px;" @on-change="selectnoticeType(agwWarningForm.noticeType)" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="agwWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
            <Select v-model="agwWarningForm.enterpriseWechatRobotIds" filterable multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select v-model="agwWarningForm.alarmDelay" filterable style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem :label="$t('alarms.common.monitorPeriod')" prop="monitorPeriod">
            <Select v-model="agwWarningForm.monitorPeriod" filterable style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input v-model="agwWarningForm.emailModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem :label="$t('alarms.common.wechatModal')" prop="wechatModal">
              <Input v-model="agwWarningForm.wechatModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>
          <div style="height: 42px;">
            <Button type="primary" size="large" style="float: right;" @click="ok('agwWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
              {{!agwWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
            </Button>
            <Button size="large" style="float: right;margin-right: 10px;"
                    @click="cancel('agwWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
            <Button size="large" @click="previousPage" style="float: right;margin-right: 10px;">{{ $t('alarms.common.lastStep') }}</Button>
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="8">
                <!-- 账户 -->
                <FormItem :label="$t('alarms.common.account')" prop="account" :label-width="70">
                  <Select v-model="agwWarningForm.account" filterable
                          @on-change="changeAccount(agwWarningForm.account)" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8" style="z-index: 200">
                <!-- 存储区域 -->
                <FormItem :label="$t('alarms.common.region')" prop="backupRegion">
                  <Select @on-change="changebackupRegion(agwWarningForm.backupRegion)"
                          v-model="agwWarningForm.backupRegion" filterable multiple :max-tag-count="1" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                    <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.allSelected') }}</Checkbox>
                    <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchECDate">{{ $t('alarms.common.search') }}</Button>
            </Row>
          </div>

          <v-table :height="459" column-width-drag is-horizontal-resize
                   style="width:100%;height:459px;margin-bottom: 15px;" :columns="column" :table-data="tableAgwDate"
                   row-hover-color="#edf7ff" :is-loading="modal_loadings" title-bg-color="#f8f8f9"
                   :select-group-change="selectChange" :select-all="selectAll"></v-table>
          <div style="height: 42px;">
            <Button type="primary" size="large" @click="nextPage" style="float: right;" :disabled="isNextClick">{{ $t('alarms.common.nextStep') }}
            </Button>
            <Button size="large" style="margin-right: 10px;float: right;"
                    @click="cancel('agwWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
    import WechatWarning from '../../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
    import TableAgw from '../agw/TableAgw.vue'

    var tableAgw = TableAgw;
    var tableAgwWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.agwWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error(this.$t('monitor.alarmRule.ruleNameRepeated')));
                    }
                })
            };
            return {
                monitorModule:23,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                    {
                        label: this.$t('alarms.common.contactGroup'),
                        value: 'contactGroup',
                        type: 1
                    }],
                addloading:false,
                singleBackupRegion:false,
                alarmDelayList:[],
                monitorPeriodList:[],
                isEdit: false,
                isShowSearch: false,
                isEditRuleName: false,
                showRuleName: false,
                modal_loadings: false,
                isShowEmail: false,
                isShowWeChat: false,
                isNext: false,
                isPrevious: true,
                selection: [],
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                isNextClick: true, //禁止点击下一步
                unit: '',
                agwWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds: [],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                 // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: this.$t('monitor.alarmRule.accountRequired'), trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: this.$t('monitor.alarmRule.alarmDelayRequired'), trigger: 'change', type: 'number'}
                    ],
                  monitorPeriod: [
                    {required: true, message: this.$t('monitor.alarmRule.monitorPeriodRequired'), trigger: 'change', type: 'number'}
                  ],
                    backupRegion: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.regionRequired'), trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: this.$t('monitor.alarmRule.ruleNameRequired'), trigger: 'blur'},
                        {type: 'string', message: this.$t('monitor.alarmRule.ruleNamePattern'), pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.notificationObjectRequired'), trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: this.$t('monitor.alarmRule.noticeTypeRequired'), trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: this.$t('monitor.alarmRule.monitorIndexRequired'), trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: this.$t('monitor.alarmRule.cycleRequired'), trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: this.$t('monitor.alarmRule.continousCycleRequired'), trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: this.$t('monitor.alarmRule.statisticsValueRequired'), trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: this.$t('monitor.alarmRule.relationshipSignRequired'), trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: this.$t('monitor.alarmRule.thresholdRequired')}
                    ],
                    contactType: [
                        {required: true, message: this.$t('monitor.alarmRule.contactTypeRequired'), trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: this.$t('monitor.alarmRule.contactGroupRequired'), trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                      {required: true, type: 'array', message: this.$t('monitor.alarmRule.enterpriseWechatRobotRequired'), trigger: 'change'}
                    ]
                },
                column: [
                    {
                        width: 60,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        type: 'selection'
                    },
                    {
                        field: 'name',
                        title: this.$t('alarms.network.AppGateway.title'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'publicIp',
                        title: this.$t('alarms.instance.ip'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'resourceGroup',
                        title: this.$t('alarms.network.AppGateway.resourceGroup'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'location',
                        title: this.$t('alarms.instance.region'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    }
                ],
                tableAgwDate: [],
                newTableAgwDateList: [],
                instanceList: [],
                compareInstanceList:[]
            }
        },

        beforeCreate: function () {
            tableAgwWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            // 下一步
            nextPage: function () {
                this.isNext = true;
                this.isPrevious = false;
                // 查询监控指标
                tableAgwWarningVue.searchMonitorIndex();
                // 查询阈值
                tableAgwWarningVue.selectMonitorIndexDefault();
                // 查询联系人组
                tableAgwWarningVue.listContactGroups();
            },
            // 上一步
            previousPage: function () {
                this.isNext = false;
                this.isPrevious = true;
            },
            init: function (id) {
                this.agwWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableAgwWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['agwWarningForm'].resetFields();
                    // 编辑
                    if (this.agwWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.isShowSearch = false;
                        this.$api.alertRule.selectAlertRule("id", this.agwWarningForm.id)
                            .then(res => {
                                //延时
                                this.agwWarningForm.alarmDelay = res.data.delay;
                                //监控时段
                                this.agwWarningForm.monitorPeriod = res.data.monitorPeriod;
                                // 账户
                                /******************************************************/
                                this.agwWarningForm.account = res.data.accountId;
                                tableAgwWarningVue.$api.account.queryAccountRegions("accountId", this.agwWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });

                               tableAgwWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                 "monitorModule":this.monitorModule,
                                 "accountId":this.agwWarningForm.account
                               })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                this.modal_loadings = true;

                                setTimeout(() => {
                                    // 存储区域
                                    this.agwWarningForm.backupRegion = res.data.regions;

                                    // 实例列表
                                    /******************************************************/
                                    this.instanceList = res.data.applicationGatewayDTOList;

                                    this.compareInstanceList=res.data.applicationGatewayDTOList;
                                    // 根据AccountId查询Instance列表
                                    tableAgwWarningVue.$api.agw.queryAccountApplicationGateways({
                                        "accountId": this.agwWarningForm.account
                                    })
                                    .then(res => {
                                        this.tableAgwDate = res.data;
                                        this.modal_loadings = false;
                                        for (var i = 0; i < this.tableAgwDate.length; i++) {
                                            for (var j = 0; j < this.compareInstanceList.length; j++) {
                                                if (this.tableAgwDate[i].name == this.compareInstanceList[j].name) {
                                                    this.tableAgwDate[i]._checked = true;
                                                }
                                            }
                                        }
                                        // 选了数据 可以点击下一步
                                        if (this.tableAgwDate.length == 0 || this.compareInstanceList.length == 0) {
                                            this.isNextClick = true;
                                        } else {
                                            this.isNextClick = false;
                                        }
                                    })
                                }, 1000)

                                this.newTableAgwDateList = res.data.applicationGatewayDTOList;


                                // 规则名称
                                this.agwWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                this.agwWarningForm.monitorIndex = res.data.monitorIndex;
                                // 周期
                                this.agwWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.agwWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.agwWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.agwWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.agwWarningForm.thresholdValue = res.data.thresholdValue;
                                // 单位
                                this.agwWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;
                                // 企业微信机器人URL
                                this.agwWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.agwWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.agwWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.agwWarningForm.notificationObject.length;i++){
                                      for(var j=0;j<this.notificationObjectList.length;j++){
                                        if(this.agwWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                           this.agwWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                        }
                                      }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.agwWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.agwWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }


                                // 报警方式
                                this.agwWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.agwWarningForm.noticeType.length; i++){

                                  if (this.agwWarningForm.noticeType[i] == '0') {
                                    this.isShowEmail = true;
                                    this.agwWarningForm.emailModal = res.data.briefReportBodyMail;
                                    this.noticeType = this.agwWarningForm.noticeType;
                                    tableAgwWarningVue.selectTemplate();
                                  }
                                  if (this.agwWarningForm.noticeType[i] == '1') {
                                    // this.isShowWeChat = true;
                                    this.agwWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                    this.checkLeastOnePersonBoundWeChat();
                                    this.noticeType = this.agwWarningForm.noticeType;
                                    tableAgwWarningVue.selectTemplate();
                                  }else if(this.agwWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }

                                }
                            })
                    } else {
                        this.tableAgwDate = [];
                        this.isEdit = false;
                        this.isShowSearch = true;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
                this.isNext = false;
                this.isPrevious = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.agwWarningForm.cycle = '';
                this.agwWarningForm.continousCycle = '';
                this.agwWarningForm.statisticsValue = '';
                this.agwWarningForm.relationshipSign = '';
                this.agwWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                tableAgwWarningVue.selectMonitorIndexDefault();
                this.unit = this.agwWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.agwWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableAgwWarningVue.selectTemplate();
                tableAgwWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                if (this.agwWarningForm.account == "" || this.agwWarningForm.account == null) {
                    return;
                }
                tableAgwWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.agwWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.agwWarningForm.cycle,
                    "continousCycle": this.agwWarningForm.continousCycle,
                    "statisticsValue": this.agwWarningForm.statisticsValue,
                    "relationshipSign": this.agwWarningForm.relationshipSign,
                    "accountId": this.agwWarningForm.account
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableAgwWarningVue.isNotEmpty(this.agwWarningForm.cycle) && tableAgwWarningVue.isNotEmpty(this.agwWarningForm.continousCycle) && tableAgwWarningVue.isNotEmpty(this.agwWarningForm.statisticsValue) && tableAgwWarningVue.isNotEmpty(this.agwWarningForm.relationshipSign) && this.agwWarningForm.id == 0) {
                        this.agwWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableAgwWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.agwWarningForm.monitorIndex,
                    "relationshipSign": this.agwWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.agwWarningForm.noticeType
                })
                .then(res => {
                    this.agwWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.agwWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
              this.isShowEmail = false;
              this.isShowWeChat = false;
              for(var i=0;i<this.agwWarningForm.noticeType.length;i++) {
                if (this.agwWarningForm.noticeType[i] == '0') {
                  this.isShowEmail = true;
                  this.noticeType = this.agwWarningForm.noticeType;
                  tableAgwWarningVue.selectTemplate();
                }
                if (this.agwWarningForm.noticeType[i] == '1') {
                  // this.isShowWeChat = true;
                  this.noticeType = this.agwWarningForm.noticeType;
                  this.checkLeastOnePersonBoundWeChat();
                  tableAgwWarningVue.selectTemplate();
                }else if(this.agwWarningForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                }
              }
            },
            //点击查询 加载全部数据
            /***********************************************************************************/
            searchECDate: function () {
                if (this.agwWarningForm.account == "" || this.agwWarningForm.account == null || this.agwWarningForm.backupRegion == "" || this.agwWarningForm.backupRegion == null) {
                    return;
                }
                this.modal_loadings = true;
                // 根据AccountId查询Instance列表
                tableAgwWarningVue.$api.agw.queryAccountApplicationGateways({
                    "accountId": this.agwWarningForm.account
                })
                .then(res => {
                    this.tableAgwDate = res.data;
                    this.modal_loadings = false;
                })
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.agwWarningForm.noticeType.length;i++){
                  if(this.agwWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.agwWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.agwWarningForm.contactType==0){
                          weChatDate.userIds=this.agwWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.agwWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.agwWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.agwWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.agwWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.agwWarningForm.userIdList=[];
              this.agwWarningForm.notificationObject=val;
              for(var i=0;i<this.agwWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.agwWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.agwWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function () {
                tableAgwWarningVue.$api.alertRule.searchMonitorIndex({
                  "monitorModule":this.monitorModule,
                  "accountId":this.agwWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableAgwWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.agwWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.agwWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableAgwWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmWayList = res.data;
              })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableAgwWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableAgwWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableAgwWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableAgwWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableAgwWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableAgwWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
                this.tableAgwDate = [];
                tableAgwWarningVue.$api.account.selectAccountByCloudPlatform("type", 2)
                .then(res => {
                    this.accountList = res.data;
                })
                // 查询方式
                tableAgwWarningVue.alarmWay();
                 // 查询报警延时
                tableAgwWarningVue.getAlarmDelay();
                //监控时段
                tableAgwWarningVue.searchMonitorPeriod();
                // 监控模块查询关联的机器人列表
                tableAgwWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableAgwWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                  "monitorModule":this.monitorModule
                })
                .then(res => {
                  this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 选择账户
            changeAccount: function () {
                if (this.agwWarningForm.account == "" || this.agwWarningForm.account == null) {
                    return;
                }
                this.agwWarningForm.backupRegion = '';
                // 清空表格
                this.tableAgwDate = [];
                this.instanceList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
                tableAgwWarningVue.$api.account.queryAccountRegions("accountId", this.agwWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableAgwWarningVue.queryContacts();
                // 查询联系人组
                tableAgwWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.agwWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.agwWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.agwWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableAgwDate = [];
                this.instanceList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
            },
            // 全选 单选
            /***********************************************************************************/
            // 单选
            selectChange(selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableAgwDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableAgwCopy = new Object();
                    TableAgwCopy.name = this.selection[i].name;
                    TableAgwCopy.accountId = this.selection[i].accountId;
                    TableAgwCopy.location = this.selection[i].location;
                    TableAgwCopy.publicIp = this.selection[i].publicIp;
                    TableAgwCopy.resourceGroup = this.selection[i].resourceGroup;
                    this.newTableAgwDateList.push(TableAgwCopy);
                }
                // 选了数据 可以点击下一步
                if (this.newTableAgwDateList.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 全选
            selectAll: function (selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableAgwDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    // 状态
                    var TableAgwCopy = new Object();
                    TableAgwCopy.name = this.selection[i].name;
                    TableAgwCopy.accountId = this.selection[i].accountId;
                    TableAgwCopy.location = this.selection[i].location;
                    TableAgwCopy.publicIp = this.selection[i].publicIp;
                    TableAgwCopy.resourceGroup = this.selection[i].resourceGroup;
                    this.newTableAgwDateList.push(TableAgwCopy);
                }
                if (this.selection.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var alertList = {
                            "alertRuleName": this.agwWarningForm.ruleName,
                            "monitorIndex": this.agwWarningForm.monitorIndex,
                            "cycle": this.agwWarningForm.cycle,
                            "continousCycle": this.agwWarningForm.continousCycle,
                            "statisticsValue": this.agwWarningForm.statisticsValue,
                            "relationshipSign": this.agwWarningForm.relationshipSign,
                            "accountId": this.agwWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.agwWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.agwWarningForm.alarmDelay,
                             "monitorPeriod":this.agwWarningForm.monitorPeriod,
                            "thresholdValue":this.agwWarningForm.thresholdValue,
                            "contactType":this.agwWarningForm.contactType,
                            "enterpriseWechatRobotIds":this.agwWarningForm.enterpriseWechatRobotIds
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.agwWarningForm.contactType == 0){
                            alertList.contactIDs = this.agwWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.agwWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.agwWarningForm.contactGroupIds;
                        }

                        if (this.agwWarningForm.id > 0) {
                            alertList.id = this.agwWarningForm.id;
                            alertList.applicationGatewayDTOList = this.newTableAgwDateList;
                            // 编辑告警
                            this.addloading=true;
                            tableAgwWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.agwWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success(this.$t('common.editSuccess'));
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowSearch = false;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            alertList.applicationGatewayDTOList = this.newTableAgwDateList;
                            tableAgwWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        tableAgw.methods.showAll();
                                        this.agwWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success(this.$t('common.addSuccess'));
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.agwWarningForm.id > 0) {
                            this.$Message.error(this.$t('common.editFail'));
                        } else {
                            this.$Message.error(this.$t('common.addFail'));
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowSearch = false;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.isNextClick = true;
                this.modal = false;
                this.$emit('on-cancel');
                this.agwWarningForm.notificationObject = [];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                // 清空表格
                this.tableAgwDate = [];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/agw/AddOrUpdateAgwWarning.vue